// Mock data for Venue Booking Management App with Subscription System

// Subscription Plans - 6 Standard Plans
export const subscriptionPlans = [
  {
    id: 'PLAN_TRIAL',
    name: 'Trial',
    duration: 15,
    durationType: 'days',
    price: 0,
    currency: '₹',
    features: [
      'All Features',
      '15 Days Access',
      'No Credit Card Required'
    ],
    description: 'Free 15-day trial with all features',
    badge: 'FREE',
    gst_inclusive: true
  },
  {
    id: 'PLAN_1_MONTH',
    name: '1 Month',
    duration: 30,
    durationType: 'days',
    price: 2359,
    base_price: 1999,
    gst_amount: 360,
    currency: '₹',
    features: [
      'All Features',
      '30 Days Access',
      'Email Support'
    ],
    description: '₹1,999 + 18% GST',
    gst_inclusive: true
  },
  {
    id: 'PLAN_3_MONTHS',
    name: '3 Months',
    duration: 90,
    durationType: 'days',
    price: 6489,
    base_price: 5499,
    gst_amount: 990,
    currency: '₹',
    features: [
      'All Features',
      '90 Days Access',
      'Priority Support',
      '8% Savings'
    ],
    description: '₹5,499 + 18% GST - Save ₹588',
    badge: 'POPULAR',
    gst_inclusive: true
  },
  {
    id: 'PLAN_6_MONTHS',
    name: '6 Months',
    duration: 180,
    durationType: 'days',
    price: 11799,
    base_price: 9999,
    gst_amount: 1800,
    currency: '₹',
    features: [
      'All Features',
      '180 Days Access',
      'Priority Support',
      '17% Savings'
    ],
    description: '₹9,999 + 18% GST - Save ₹2,355',
    gst_inclusive: true
  },
  {
    id: 'PLAN_12_MONTHS',
    name: '12 Months',
    duration: 365,
    durationType: 'days',
    price: 17699,
    base_price: 14999,
    gst_amount: 2700,
    currency: '₹',
    features: [
      'All Features',
      '365 Days Access',
      'Priority Support',
      '37% Savings'
    ],
    description: '₹14,999 + 18% GST - Save ₹10,609',
    badge: 'BEST VALUE',
    gst_inclusive: true
  },
  {
    id: 'PLAN_5_YEARS',
    name: '5 Years',
    duration: 1825,
    durationType: 'days',
    price: 58999,
    base_price: 49999,
    gst_amount: 9000,
    currency: '₹',
    features: [
      'All Features for 5 Years',
      '5 Years Updates',
      'Priority Support'
    ],
    description: '₹49,999 + 18% GST - Best Long-term Value',
    badge: '5 YEARS',
    gst_inclusive: true,
    savings: 82541,
    savingsVsMonthly: '₹82,541 vs 1 Month Plan'
  }
];

export const users = [
  { 
    id: 'MASTER_001', 
    email: 'info@myvenuemate.in', 
    password: 'KaRtHiKyO@13121989', 
    role: 'master', 
    name: 'Master Admin', 
    phone: '+91 00000 00000',
    isMaster: true,
    canDelete: false,
    createdAt: '2025-01-01T00:00:00Z',
    subscription: null
  },
  { 
    id: 'DEMO_ADMIN_001', 
    email: 'demoadmin@myvenuemate.in', 
    password: 'demo123', 
    role: 'admin', 
    name: 'Demo Admin', 
    phone: '+91 99999 88888',
    venueName: 'Demo Venue',
    isMaster: false,
    canDelete: true,
    createdAt: '2025-03-01T10:00:00Z',
    adminId: 'DEMO_ADMIN_001',
    subscription: {
      status: 'active',
      plan: 'PLAN_PRO',
      startDate: '2025-12-01T10:00:00Z',
      expiryDate: '2026-01-01T10:00:00Z',
      autoRenew: true,
      paymentMethod: 'razorpay',
      customizations: null
    }
  },
  { 
    id: 'CLIENT_DEMO_001', 
    email: 'demo@venue.com', 
    password: 'demo1234', 
    role: 'admin', 
    name: 'Rajesh Sharma', 
    phone: '+91 98765 43210',
    venueName: 'Royal Banquets & Events',
    isMaster: false,
    canDelete: true,
    createdAt: '2025-01-15T10:00:00Z',
    adminId: 'CLIENT_DEMO_001',
    subscription: {
      status: 'active',
      plan: 'PLAN_PRO',
      startDate: '2025-01-15T10:00:00Z',
      expiryDate: '2026-01-15T10:00:00Z',
      autoRenew: true,
      paymentMethod: 'razorpay',
      customizations: null
    }
  },
  { 
    id: 'DEMO_STAFF_001', 
    email: 'demostaff@myvenuemate.in', 
    password: 'demo123', 
    role: 'staff', 
    name: 'Demo Staff', 
    phone: '+91 99999 77777',
    isMaster: false,
    canDelete: true,
    createdAt: '2025-03-02T10:00:00Z',
    adminId: 'DEMO_ADMIN_001',
    subscription: null
  }
];

export const bookings = [
  {
    id: 'BK001',
    venueName: 'Grand Ballroom',
    customerName: 'Amit & Priya Sharma',
    customerPhone: '+91 98765 43210',
    customerEmail: 'amit.sharma@gmail.com',
    eventType: 'Wedding Reception',
    eventDate: '2025-12-28',
    startTime: '19:00',
    endTime: '23:30',
    guests: 350,
    totalAmount: 285000,
    amount: 285000,
    advancePaid: 100000,
    status: 'confirmed',
    bookingType: 'confirmed',
    payments: [
      { id: 'PAY001', amount: 100000, date: '2025-11-15', method: 'Bank Transfer', notes: 'Booking confirmation advance' },
      { id: 'PAY002', amount: 85000, date: '2025-12-05', method: 'UPI', notes: 'Second installment' }
    ],
    createdAt: '2025-11-10T10:00:00Z',
    notes: 'Jain vegetarian menu, Stage decoration for sangeet ceremony'
  },
  {
    id: 'BK002',
    venueName: 'Garden Pavilion',
    customerName: 'TCS Bangalore',
    customerPhone: '+91 80 6789 5432',
    customerEmail: 'events@tcs.com',
    eventType: 'Corporate Annual Day',
    eventDate: '2025-12-15',
    startTime: '10:00',
    endTime: '18:00',
    guests: 500,
    totalAmount: 425000,
    amount: 425000,
    advancePaid: 150000,
    status: 'confirmed',
    bookingType: 'confirmed',
    payments: [
      { id: 'PAY003', amount: 150000, date: '2025-11-20', method: 'Cheque', notes: 'Advance payment via company cheque' },
      { id: 'PAY004', amount: 150000, date: '2025-12-01', method: 'NEFT', notes: 'Partial payment - stage 2' }
    ],
    createdAt: '2025-11-15T14:30:00Z',
    notes: 'Audio-visual setup, LED screens, lunch and hi-tea arrangement'
  },
  {
    id: 'BK003',
    venueName: 'Rooftop Terrace',
    customerName: 'Ravi Kumar',
    customerPhone: '+91 99999 12345',
    customerEmail: 'ravi.kumar@yahoo.in',
    eventType: 'Birthday Party',
    eventDate: '2025-12-20',
    startTime: '18:00',
    endTime: '22:00',
    guests: 80,
    totalAmount: 55000,
    amount: 55000,
    advancePaid: 20000,
    status: 'confirmed',
    bookingType: 'confirmed',
    payments: [
      { id: 'PAY005', amount: 20000, date: '2025-12-10', method: 'Cash', notes: 'Advance booking amount' }
    ],
    createdAt: '2025-12-08T11:00:00Z',
    notes: 'DJ, Live music, Cake included'
  },
  {
    id: 'BK004',
    venueName: 'Conference Hall A',
    customerName: 'Infosys Learning Center',
    customerPhone: '+91 80 4567 8901',
    customerEmail: 'training@infosys.com',
    eventType: 'Training Workshop',
    eventDate: '2025-12-18',
    startTime: '09:00',
    endTime: '17:00',
    guests: 150,
    totalAmount: 75000,
    amount: 75000,
    advancePaid: 75000,
    status: 'confirmed',
    bookingType: 'confirmed',
    payments: [
      { id: 'PAY006', amount: 75000, date: '2025-12-05', method: 'Bank Transfer', notes: 'Full payment in advance' }
    ],
    createdAt: '2025-11-28T09:00:00Z',
    notes: 'Projector, Whiteboard, Lunch and snacks'
  },
  {
    id: 'BK005',
    venueName: 'Lakeside Gazebo',
    customerName: 'Deepak & Anjali Reddy',
    customerPhone: '+91 98765 11111',
    customerEmail: 'deepak.reddy@gmail.com',
    eventType: 'Engagement Ceremony',
    eventDate: '2025-12-25',
    startTime: '17:00',
    endTime: '21:00',
    guests: 120,
    totalAmount: 95000,
    amount: 95000,
    advancePaid: 30000,
    status: 'confirmed',
    bookingType: 'confirmed',
    payments: [
      { id: 'PAY007', amount: 30000, date: '2025-12-08', method: 'UPI', notes: 'Token amount' }
    ],
    createdAt: '2025-12-05T15:30:00Z',
    notes: 'Traditional South Indian engagement, Vegetarian catering'
  },
  {
    id: 'BK006',
    venueName: 'Grand Ballroom',
    customerName: 'Maintenance Block',
    customerPhone: '',
    customerEmail: '',
    eventType: 'Venue Maintenance',
    eventDate: '2025-12-10',
    startTime: '00:00',
    endTime: '23:59',
    guests: 0,
    amount: 0,
    advancePaid: 0,
    status: 'confirmed',
    bookingType: 'blocked',
    createdAt: '2025-11-01T08:00:00Z',
    notes: 'Annual deep cleaning and maintenance'
  },
  {
    id: 'BK007',
    venueName: 'Garden Pavilion',
    customerName: 'Sanjay Gupta',
    customerPhone: '+91 98765 22222',
    customerEmail: 'sanjay.gupta@outlook.com',
    eventType: 'Retirement Party',
    eventDate: '2025-12-22',
    startTime: '12:00',
    endTime: '16:00',
    guests: 60,
    totalAmount: 42000,
    amount: 42000,
    advancePaid: 10000,
    status: 'confirmed',
    bookingType: 'confirmed',
    payments: [
      { id: 'PAY008', amount: 10000, date: '2025-12-12', method: 'Cash', notes: 'Advance' }
    ],
    createdAt: '2025-12-10T10:00:00Z',
    notes: 'Afternoon lunch party, Multi-cuisine menu'
  },
  {
    id: 'BK008',
    venueName: 'Rooftop Terrace',
    customerName: 'Meera Krishnan',
    customerPhone: '+91 99999 33333',
    customerEmail: 'meera.k@gmail.com',
    eventType: 'Baby Shower',
    eventDate: '2025-12-30',
    startTime: '15:00',
    endTime: '19:00',
    guests: 50,
    totalAmount: 38000,
    amount: 38000,
    advancePaid: 15000,
    status: 'confirmed',
    bookingType: 'confirmed',
    payments: [
      { id: 'PAY009', amount: 15000, date: '2025-12-15', method: 'Google Pay', notes: 'Booking advance' }
    ],
    createdAt: '2025-12-12T16:00:00Z',
    notes: 'Baby shower theme decoration, Vegetarian snacks'
  },
  {
    id: 'BK009',
    venueName: 'Conference Hall A',
    customerName: 'Wipro Technologies',
    customerPhone: '+91 80 9876 5432',
    customerEmail: 'hr@wipro.com',
    eventType: 'Product Launch',
    eventDate: '2026-01-05',
    startTime: '14:00',
    endTime: '18:00',
    guests: 200,
    totalAmount: 125000,
    amount: 125000,
    advancePaid: 40000,
    status: 'confirmed',
    bookingType: 'confirmed',
    payments: [
      { id: 'PAY010', amount: 40000, date: '2025-12-18', method: 'Cheque', notes: 'Advance payment' }
    ],
    createdAt: '2025-12-16T11:00:00Z',
    notes: 'AV equipment, stage setup, refreshments'
  },
  {
    id: 'BK010',
    venueName: 'Lakeside Gazebo',
    customerName: 'Kavita Sharma',
    customerPhone: '+91 98765 44444',
    customerEmail: 'kavita.sharma@yahoo.com',
    eventType: 'Mehendi Ceremony',
    eventDate: '2025-12-27',
    startTime: '10:00',
    endTime: '14:00',
    guests: 100,
    totalAmount: 65000,
    amount: 65000,
    advancePaid: 25000,
    status: 'confirmed',
    bookingType: 'confirmed',
    payments: [
      { id: 'PAY011', amount: 25000, date: '2025-12-10', method: 'Bank Transfer', notes: 'Token' }
    ],
    createdAt: '2025-12-08T14:00:00Z',
    notes: 'Traditional Mehendi setup, Lunch included'
  }
];

export const leads = [
  {
    id: 'LD001',
    name: 'Rahul & Pooja Agarwal',
    phone: '+91 98765 55555',
    email: 'rahul.agarwal@gmail.com',
    eventType: 'Wedding',
    expectedDate: '2026-02-14',
    priority: 'hot',
    expectedGuests: 400,
    budget: 350000,
    status: 'new',
    source: 'Google Search',
    lastContact: '2025-12-01T10:00:00Z',
    followUpDate: '2026-01-05',
    bookingDateFrom: '2026-02-14',
    bookingTimeFrom: '18:00',
    bookingDateTo: '2026-02-15',
    bookingTimeTo: '02:00',
    notes: 'Looking for 2-day wedding event, interested in Grand Ballroom and Garden Pavilion',
    assignedTo: 'Sales Team',
    converted: false
  },
  {
    id: 'LD002',
    name: 'Mahindra & Mahindra Ltd',
    phone: '+91 22 6789 1234',
    email: 'events@mahindra.com',
    eventType: 'Corporate Conference',
    expectedDate: '2026-01-20',
    priority: 'hot',
    expectedGuests: 300,
    budget: 250000,
    status: 'contacted',
    source: 'LinkedIn',
    lastContact: '2025-12-03T14:30:00Z',
    followUpDate: '2025-12-20',
    bookingDateFrom: '2026-01-20',
    bookingTimeFrom: '09:00',
    bookingDateTo: '2026-01-20',
    bookingTimeTo: '18:00',
    notes: 'Annual sales conference, need AV equipment, projector and catering',
    assignedTo: 'Corporate Team',
    converted: false
  },
  {
    id: 'LD003',
    name: 'Suresh Iyer',
    phone: '+91 98765 66666',
    email: 'suresh.iyer@yahoo.in',
    eventType: 'Retirement Party',
    expectedDate: '2026-01-15',
    priority: 'warm',
    expectedGuests: 80,
    budget: 55000,
    status: 'contacted',
    source: 'Facebook',
    lastContact: '2025-12-02T11:00:00Z',
    followUpDate: '2025-12-25',
    bookingDateFrom: '2026-01-15',
    bookingTimeFrom: '12:00',
    bookingDateTo: '2026-01-15',
    bookingTimeTo: '16:00',
    notes: 'Afternoon lunch party, traditional South Indian menu preferred',
    assignedTo: 'Sales Team',
    converted: false
  },
  {
    id: 'LD004',
    name: 'Neha Sharma',
    phone: '+91 98765 77777',
    email: 'neha.sharma@outlook.com',
    eventType: 'Baby Shower',
    expectedDate: '2026-01-25',
    priority: 'warm',
    expectedGuests: 60,
    budget: 40000,
    status: 'won',
    source: 'Instagram',
    lastContact: '2025-12-04T15:00:00Z',
    followUpDate: '',
    bookingDateFrom: '2026-01-25',
    bookingTimeFrom: '14:00',
    bookingDateTo: '2026-01-25',
    bookingTimeTo: '18:00',
    notes: 'Converted to booking! Pink theme decoration',
    assignedTo: 'Sales Team',
    converted: true
  },
  {
    id: 'LD005',
    name: 'Vikram Rao',
    phone: '+91 98765 88888',
    email: 'vikram.rao@gmail.com',
    eventType: 'Birthday Party',
    expectedDate: '2026-02-10',
    priority: 'cold',
    expectedGuests: 50,
    budget: 35000,
    status: 'new',
    source: 'Walk-in',
    lastContact: '2025-11-28T10:00:00Z',
    followUpDate: '2026-01-10',
    bookingDateFrom: '2026-02-10',
    bookingTimeFrom: '19:00',
    bookingDateTo: '2026-02-10',
    bookingTimeTo: '23:00',
    notes: 'Inquired about Rooftop Terrace, still comparing venues',
    assignedTo: 'Sales Team',
    converted: false
  },
  {
    id: 'LD006',
    name: 'Tata Consultancy Services',
    phone: '+91 80 4321 8765',
    email: 'hr.bangalore@tcs.com',
    eventType: 'Team Building Event',
    expectedDate: '2026-02-01',
    priority: 'hot',
    expectedGuests: 200,
    budget: 180000,
    status: 'contacted',
    source: 'Email Campaign',
    lastContact: '2025-12-05T16:00:00Z',
    followUpDate: '2025-12-18',
    bookingDateFrom: '2026-02-01',
    bookingTimeFrom: '10:00',
    bookingDateTo: '2026-02-01',
    bookingTimeTo: '18:00',
    notes: 'Team outing with activities, lunch and hi-tea',
    assignedTo: 'Corporate Team',
    converted: false
  },
  {
    id: 'LD007',
    name: 'Anita Deshmukh',
    phone: '+91 98765 99999',
    email: 'anita.d@gmail.com',
    eventType: 'Anniversary Celebration',
    expectedDate: '2026-01-30',
    priority: 'warm',
    expectedGuests: 100,
    budget: 75000,
    status: 'contacted',
    source: 'Referral',
    lastContact: '2025-12-01T12:00:00Z',
    followUpDate: '2025-12-22',
    bookingDateFrom: '2026-01-30',
    bookingTimeFrom: '19:00',
    bookingDateTo: '2026-01-30',
    bookingTimeTo: '23:00',
    notes: '25th wedding anniversary, looking for elegant setup',
    assignedTo: 'Sales Team',
    converted: false
  },
  {
    id: 'LD008',
    name: 'Rajesh Patel',
    phone: '+91 98765 00000',
    email: 'rajesh.patel@yahoo.com',
    eventType: 'Product Launch',
    expectedDate: '2026-01-18',
    priority: 'cold',
    expectedGuests: 150,
    budget: 95000,
    status: 'lost',
    source: 'Cold Call',
    lastContact: '2025-11-25T09:00:00Z',
    followUpDate: '',
    bookingDateFrom: '2026-01-18',
    bookingTimeFrom: '15:00',
    bookingDateTo: '2026-01-18',
    bookingTimeTo: '19:00',
    notes: 'Went with competitor venue - lower pricing',
    assignedTo: 'Sales Team',
    converted: false
  }
];

export const inventoryItems = [
  {
    id: 'INV001',
    name: 'Round Tables (8-seater)',
    category: 'Furniture',
    quantity: 50,
    available: 35,
    condition: 'good',
    lastMaintenance: '2025-06-01',
    notes: '15 tables currently in use'
  },
  {
    id: 'INV002',
    name: 'Chiavari Chairs',
    category: 'Furniture',
    quantity: 400,
    available: 250,
    condition: 'good',
    lastMaintenance: '2025-06-15',
    notes: '150 chairs booked for upcoming events'
  },
  {
    id: 'INV003',
    name: 'Projector & Screen',
    category: 'AV Equipment',
    quantity: 5,
    available: 3,
    condition: 'excellent',
    lastMaintenance: '2025-07-01',
    notes: '2 projectors in use'
  },
  {
    id: 'INV004',
    name: 'Wireless Microphones',
    category: 'AV Equipment',
    quantity: 20,
    available: 15,
    condition: 'good',
    lastMaintenance: '2025-06-20',
    notes: 'Batteries need regular checking'
  },
  {
    id: 'INV005',
    name: 'Stage Lighting Kit',
    category: 'Lighting',
    quantity: 8,
    available: 6,
    condition: 'good',
    lastMaintenance: '2025-06-10',
    notes: '2 kits under maintenance'
  },
  {
    id: 'INV006',
    name: 'Table Linens (White)',
    category: 'Decor',
    quantity: 100,
    available: 60,
    condition: 'excellent',
    lastMaintenance: '2025-07-05',
    notes: 'Recently cleaned batch'
  },
  {
    id: 'INV007',
    name: 'Dance Floor Panels',
    category: 'Flooring',
    quantity: 200,
    available: 150,
    condition: 'good',
    lastMaintenance: '2025-05-25',
    notes: '50 panels in use'
  },
  {
    id: 'INV008',
    name: 'Folding Buffet Tables',
    category: 'Furniture',
    quantity: 30,
    available: 22,
    condition: 'good',
    lastMaintenance: '2025-06-05',
    notes: '8 tables currently deployed'
  }
];

export const venues = [
  {
    id: 'VEN001',
    name: 'Grand Ballroom',
    type: 'Ballroom',
    capacity: 300,
    location: 'Connaught Place, New Delhi, Delhi 110001',
    pricePerHour: 4500,
    pricePerDay: 45000,
    amenities: ['Stage', 'Sound System', 'Lighting', 'Dance Floor', 'Kitchen Access', 'Parking'],
    status: 'active',
    description: 'Elegant ballroom perfect for weddings and large corporate events. Features crystal chandeliers and hardwood floors.',
    image: 'https://images.unsplash.com/photo-1519167758481-83f29da8c898?w=400',
    area: '5000 sq ft',
    setupTime: '3 hours',
    cleanupTime: '2 hours'
  },
  {
    id: 'VEN002',
    name: 'Garden Pavilion',
    type: 'Outdoor',
    capacity: 150,
    location: 'Koramangala, Bengaluru, Karnataka 560034',
    pricePerHour: 2800,
    pricePerDay: 28000,
    amenities: ['Garden View', 'Natural Lighting', 'Covered Area', 'Bar Setup', 'Parking'],
    status: 'active',
    description: 'Beautiful outdoor pavilion surrounded by lush gardens. Ideal for daytime events and garden parties.',
    image: 'https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=400',
    area: '3000 sq ft',
    setupTime: '2 hours',
    cleanupTime: '1.5 hours'
  },
  {
    id: 'VEN003',
    name: 'Rooftop Terrace',
    type: 'Rooftop',
    capacity: 100,
    location: 'Bandra West, Mumbai, Maharashtra 400050',
    pricePerHour: 3500,
    pricePerDay: 35000,
    amenities: ['Skyline View', 'Open Bar', 'Lounge Seating', 'Climate Control', 'Photography Spot'],
    status: 'active',
    description: 'Stunning rooftop venue with panoramic city views. Perfect for cocktail parties and intimate celebrations.',
    image: 'https://images.unsplash.com/photo-1478146896981-b80fe463b330?w=400',
    area: '2500 sq ft',
    setupTime: '2 hours',
    cleanupTime: '1.5 hours'
  },
  {
    id: 'VEN004',
    name: 'Conference Hall A',
    type: 'Conference',
    capacity: 200,
    location: 'Cyber City, Gurgaon, Haryana 122002',
    pricePerHour: 3200,
    pricePerDay: 32000,
    amenities: ['AV Equipment', 'Projector', 'Whiteboard', 'WiFi', 'Coffee Station', 'Breakout Rooms'],
    status: 'active',
    description: 'Professional conference hall equipped with state-of-the-art technology for business meetings and seminars.',
    image: 'https://images.unsplash.com/photo-1505373877841-8d25f7d46678?w=400',
    area: '4000 sq ft',
    setupTime: '1 hour',
    cleanupTime: '1 hour'
  },
  {
    id: 'VEN005',
    name: 'Lakeside Gazebo',
    type: 'Outdoor',
    capacity: 80,
    location: 'Powai, Mumbai, Maharashtra 400076',
    pricePerHour: 2200,
    pricePerDay: 22000,
    amenities: ['Lake View', 'Gazebo Structure', 'String Lights', 'Dock Access', 'Parking'],
    status: 'active',
    description: 'Romantic lakeside venue with a charming gazebo. Perfect for intimate weddings and small gatherings.',
    image: 'https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=400',
    area: '2000 sq ft',
    setupTime: '2 hours',
    cleanupTime: '1.5 hours'
  },
  {
    id: 'VEN006',
    name: 'Industrial Loft',
    type: 'Loft',
    capacity: 120,
    location: 'Indiranagar, Bengaluru, Karnataka 560038',
    pricePerHour: 3300,
    pricePerDay: 33000,
    amenities: ['Exposed Brick', 'High Ceilings', 'Natural Light', 'Modern Kitchen', 'Parking', 'Loading Dock'],
    status: 'active',
    description: 'Trendy industrial loft space with urban charm. Ideal for creative events, product launches, and modern celebrations.',
    image: 'https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=400',
    area: '3500 sq ft',
    setupTime: '2.5 hours',
    cleanupTime: '2 hours'
  },
  {
    id: 'VEN007',
    name: 'Vintage Theater',
    type: 'Theater',
    capacity: 250,
    location: 'Colaba, Mumbai, Maharashtra 400005',
    pricePerHour: 4000,
    pricePerDay: 40000,
    amenities: ['Stage', 'Seating', 'Lighting', 'Sound System', 'Backstage', 'Dressing Rooms'],
    status: 'maintenance',
    description: 'Historic theater with vintage charm and modern amenities. Perfect for performances, presentations, and unique events.',
    image: 'https://images.unsplash.com/photo-1503095396549-807759245b35?w=400',
    area: '6000 sq ft',
    setupTime: '4 hours',
    cleanupTime: '3 hours'
  },
  {
    id: 'VEN008',
    name: 'Beachfront Pavilion',
    type: 'Outdoor',
    capacity: 180,
    location: 'Candolim Beach, Goa 403515',
    pricePerHour: 4500,
    pricePerDay: 48000,
    amenities: ['Beach Access', 'Ocean View', 'Covered Area', 'Fire Pit', 'BBQ Grills', 'Parking'],
    status: 'inactive',
    description: 'Exclusive beachfront venue with direct ocean access. Stunning sunset views for memorable events.',
    image: 'https://images.unsplash.com/photo-1510076857177-7470076d4098?w=400',
    area: '3800 sq ft',
    setupTime: '3 hours',
    cleanupTime: '2.5 hours'
  }
];

export const dashboardStats = {
  totalBookings: 47,
  confirmedBookings: 35,
  pendingBookings: 8,
  cancelledBookings: 4,
  totalRevenue: 3850000,
  revenueThisMonth: 725000,
  pendingPayments: 385000,
  activeLeads: 23,
  hotLeads: 8,
  conversionRate: 68,
  totalVenues: 8,
  activeVenues: 6
};

export const recentActivity = [
  { id: 1, type: 'booking', message: 'New booking created for Grand Ballroom', time: '2 hours ago', user: 'Sarah Staff' },
  { id: 2, type: 'lead', message: 'Lead converted to booking - Frank Miller', time: '5 hours ago', user: 'John Admin' },
  { id: 3, type: 'payment', message: 'Payment received for BK001 - $5,000', time: '1 day ago', user: 'System' },
  { id: 4, type: 'inventory', message: 'Inventory updated - Chiavari Chairs', time: '1 day ago', user: 'Mike Master' },
  { id: 5, type: 'lead', message: 'New lead added - Iris Martinez', time: '2 days ago', user: 'Sarah Staff' }
];

// Helper functions for localStorage-based mock operations
export const getMockUser = () => {
  return JSON.parse(localStorage.getItem('currentUser'));
};

export const setMockUser = (user) => {
  localStorage.setItem('currentUser', JSON.stringify(user));
};

export const clearMockUser = () => {
  localStorage.removeItem('currentUser');
};

export const getMockBookings = () => {
  const stored = localStorage.getItem('mockBookings');
  if (stored) return JSON.parse(stored);
  localStorage.setItem('mockBookings', JSON.stringify(bookings));
  return bookings;
};

export const saveMockBookings = (bookingsData) => {
  localStorage.setItem('mockBookings', JSON.stringify(bookingsData));
};

export const getMockLeads = () => {
  const stored = localStorage.getItem('mockLeads');
  if (stored) return JSON.parse(stored);
  localStorage.setItem('mockLeads', JSON.stringify(leads));
  return leads;
};

export const saveMockLeads = (leadsData) => {
  localStorage.setItem('mockLeads', JSON.stringify(leadsData));
};

export const getMockInventory = () => {
  const stored = localStorage.getItem('mockInventory');
  if (stored) return JSON.parse(stored);
  localStorage.setItem('mockInventory', JSON.stringify(inventoryItems));
  return inventoryItems;
};

export const saveMockInventory = (inventoryData) => {
  localStorage.setItem('mockInventory', JSON.stringify(inventoryData));
};

export const getMockVenues = () => {
  const stored = localStorage.getItem('mockVenues');
  if (stored) return JSON.parse(stored);
  localStorage.setItem('mockVenues', JSON.stringify(venues));
  return venues;
};

export const saveMockVenues = (venuesData) => {
  localStorage.setItem('mockVenues', JSON.stringify(venuesData));
};

// User management functions
export const getMockUsers = () => {
  const stored = localStorage.getItem('mockUsers');
  let usersData = stored ? JSON.parse(stored) : users;
  
  // CRITICAL: Always ensure master account exists and is protected
  const masterAccount = users.find(u => u.isMaster === true);
  const currentMaster = usersData.find(u => u.email === 'info@myvenuemate.in');
  
  if (!currentMaster || currentMaster.role !== 'master' || !currentMaster.isMaster) {
    // Master account missing or corrupted - restore it
    usersData = usersData.filter(u => u.email !== 'info@myvenuemate.in');
    usersData.unshift(masterAccount);
    localStorage.setItem('mockUsers', JSON.stringify(usersData));
  }
  
  return usersData;
};

export const saveMockUsers = (usersData) => {
  // CRITICAL: Prevent master account modification
  const masterAccount = users.find(u => u.isMaster === true);
  const updatedMaster = usersData.find(u => u.email === 'info@myvenuemate.in');
  
  // If master account was modified or removed, restore original
  if (!updatedMaster || updatedMaster.role !== 'master' || !updatedMaster.isMaster) {
    usersData = usersData.filter(u => u.email !== 'info@myvenuemate.in');
    usersData.unshift(masterAccount);
  } else {
    // Even if present, ensure it has correct properties
    const masterIndex = usersData.findIndex(u => u.email === 'info@myvenuemate.in');
    usersData[masterIndex] = { ...masterAccount };
  }
  
  localStorage.setItem('mockUsers', JSON.stringify(usersData));
};

// Utility function to fix corrupted master account
export const fixMasterAccount = () => {
  const masterAccount = users.find(u => u.isMaster === true);
  const stored = localStorage.getItem('mockUsers');
  let usersData = stored ? JSON.parse(stored) : users;
  
  // Remove any corrupted master account
  usersData = usersData.filter(u => u.email !== 'info@myvenuemate.in');
  
  // Add back the original master account
  usersData.unshift(masterAccount);
  
  localStorage.setItem('mockUsers', JSON.stringify(usersData));
  return usersData;
};

// Payment History
export const paymentHistory = [
  {
    id: 'PAY_001',
    userId: 'DEMO_ADMIN_001',
    planId: 'PLAN_PRO',
    amount: 5999,
    currency: '₹',
    status: 'success',
    paymentMethod: 'razorpay',
    transactionId: 'pay_demo_razorpay_001',
    paymentDate: '2025-03-01T10:00:00Z',
    invoiceUrl: null
  }
];

export const getMockPayments = () => {
  const stored = localStorage.getItem('mockPayments');
  if (stored) return JSON.parse(stored);
  localStorage.setItem('mockPayments', JSON.stringify(paymentHistory));
  return paymentHistory;
};

export const saveMockPayments = (paymentsData) => {
  localStorage.setItem('mockPayments', JSON.stringify(paymentsData));
};

// Notifications
export const notifications = [
  {
    id: 'NOTIF_001',
    userId: 'DEMO_ADMIN_001',
    type: 'subscription_approved',
    title: 'Subscription Activated',
    message: 'Your Pro plan subscription has been activated successfully!',
    read: false,
    createdAt: '2025-03-01T10:00:00Z'
  }
];

export const getMockNotifications = () => {
  const stored = localStorage.getItem('mockNotifications');
  if (stored) return JSON.parse(stored);
  localStorage.setItem('mockNotifications', JSON.stringify(notifications));
  return notifications;
};

export const saveMockNotifications = (notificationsData) => {
  localStorage.setItem('mockNotifications', JSON.stringify(notificationsData));
};

export const getSubscriptionPlans = () => {
  return subscriptionPlans;
};